import React from 'react';
import {
  isAuthenticExpressionCompleteModalDataType,
  isStudyCelebrationModalDataType,
  isMiniStoryCompleteModalDataType,
} from '@datatype/iyagigo/type';
import StudyCelebrationModal from '@component/iyagigo/modal/content-modal/study-celebration-modal';
import { useTypedSelector } from '@hook/common/useStore';
import ModalTemplate from '@component/common/modal/modal-template';
import MiniStoryCompleteModal from '@component/iyagigo/modal/content-modal/study-complete-modal/mini-story-complete-modal';
import AuthenticExpressionCompleteModal from '@component/iyagigo/modal/content-modal/study-complete-modal/authentic-expression-complete-modal';

const ContentModal: React.FC = () => {
  const data = useTypedSelector((state) => state.rootReducer?.modalReducer?.contentModalData) || null;

  return (
    <ModalTemplate hideLogo>
      {isStudyCelebrationModalDataType(data) && <StudyCelebrationModal data={data.data} />}
      {isMiniStoryCompleteModalDataType(data) && <MiniStoryCompleteModal />}
      {isAuthenticExpressionCompleteModalDataType(data) && <AuthenticExpressionCompleteModal />}
    </ModalTemplate>
  );
};

export default ContentModal;
